import React from 'react';
import useMultipleLiveStreams from '../hooks/useMultipleLiveStreams';

// New components
//import LiveHeader from '../component/core/Livepage/LiveHeader';
import AllLiveStreams from '../component/core/Livepage/AllLiveStreams';
// import LiveChatSection from '../component/core/Livepage/LiveChatSection';
import ComingSoonTemples from '../component/core/Livepage/ComingSoonTemples';
import CTASection from '../component/core/Livepage/CTASection';
import Footer from '../component/common/Footer';

const Live = () => {
  const { liveStreams, loading, error } = useMultipleLiveStreams();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 pt-20">
      {/* Page Header */}
      {/* <LiveHeader /> */}

      {/* All Live Streams Grid */}
      <AllLiveStreams 
        liveStreams={liveStreams} 
        loading={loading} 
        error={error} 
      />

      {/* Live Chat Section - Commented out */}
      {/* <LiveChatSection /> */}

      {/* Coming Soon Temples */}
      <ComingSoonTemples />

      {/* CTA Section */}
      <CTASection />

      {/* Footer */}
      <Footer />

    </div>
  );
};

export default Live;
